import {
  Stack,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import type { Props } from './types';
import messages from '../messages';

function NotEnoughInformation({ intl, message }: Props) {
  return (
    <Stack spacing={1} padding={2} paddingRight={6}>
      <Typography variant="titleSmall" fontWeight="bold">
        {intl.formatMessage(messages.notEnoughInformation)}
      </Typography>
      <Stack spacing={1}>
        <Typography variant="bodySmall">{message}</Typography>
      </Stack>
    </Stack>
  );
}

export default NotEnoughInformation;
